import React from 'react';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { Login2Icon } from "@solar-icons/react/outline/login-2";
import { ArrowRightIcon } from "@solar-icons/react/outline/arrow-right";
import { ShieldCheckIcon } from "@solar-icons/react/outline/shield-check";
import { BoxMinimalisticIcon } from "@solar-icons/react/outline/box-minimalistic";
import { InboxLineIcon } from "@solar-icons/react/outline/inbox-line";
import { RouteIcon } from "@solar-icons/react/outline/route";
import { ArrowRightUpIcon } from "@solar-icons/react/outline/arrow-right-up";
import './landing.less';
import { BaseColor } from '../../config/env';

const cardShadow = '0px 32px 64px 0px rgba(10,38,26,0.10), 0px 4px 8px 0px rgba(10,38,26,0.04)';

// Aset dekorasi diekspor Figma dalam rona hijau (#158550). Geser hue-nya
// mengikuti BaseColor agar ilustrasi senada dengan tema (putih/hitam/abu tak terpengaruh).
const hexToHue = (hex) => {
  const n = hex.replace('#', '');
  const r = parseInt(n.slice(0, 2), 16) / 255, g = parseInt(n.slice(2, 4), 16) / 255, b = parseInt(n.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  if (max === min) return 0;
  const d = max - min;
  const h = max === r ? ((g - b) / d + (g < b ? 6 : 0)) : max === g ? ((b - r) / d + 2) : ((r - g) / d + 4);
  return h * 60;
};
const decoDelta = Math.round((hexToHue(BaseColor) - hexToHue('#158550') + 360) % 360);
const decoStyle = (decoDelta === 0 || decoDelta === 360) ? undefined : { filter: `hue-rotate(${decoDelta}deg)` };

const FloatCard = ({ style, children }) => (
  <div className="iacas-float" style={{
    position: 'absolute', background: '#fff', border: '1px solid #eef2f0',
    borderRadius: 24, padding: 20, boxShadow: cardShadow, zIndex: 3, ...style,
  }}>
    {children}
  </div>
);

export default () => {
  const history = useHistory();
  const goLogin = () => history.push('/workspace/login');
  const goWorkflow = () => history.push('/workspace/login');

  return (
    <div className="iacas-landing">
      <div className="iacas-hero">
        <header className="iacas-header">
          <div className="iacas-logo">
            <img src="/images/iacas.png" alt="IACAS" />
            <div className="iacas-wordmark">
              <strong>IACAS</strong>
              <span>Integrated Airline &amp; Customs Automation System</span>
            </div>
          </div>
          <Button type="primary" className="iacas-btn" onClick={goLogin} icon={<Login2Icon size={18} />}>
            Masuk
          </Button>
        </header>

        <div className="iacas-copy">
          <h1 className="iacas-title">
            Kargo udara bergerak cepat,<br />
            <span>kepabeanan tetap tepat.</span>
          </h1>
          <p className="iacas-desc">
            IACAS menghubungkan maskapai, gudang TPS, dan Bea Cukai dalam satu alur dari
            penerimaan airwaybill, gate in &amp; gate out, hingga pengiriman data kepabeanan secara real-time.
          </p>
          <div className="iacas-cta">
            <Button type="primary" size="large" className="iacas-btn-lg" onClick={goLogin}>
              Masuk ke Dashboard <ArrowRightIcon size={18} />
            </Button>
            <Button size="large" className="iacas-btn-lg ghost" onClick={goWorkflow}>
              Pelajari alur kerja
            </Button>
          </div>
        </div>

        <div className="iacas-visual">
          <img className="iacas-routes" src="/images/route-lines.svg" alt="" aria-hidden style={decoStyle} />
          <img className="iacas-glow" src="/images/glow-ring.png" alt="" aria-hidden style={decoStyle} />
          <img className="iacas-disc" src="/images/soft-disc.svg" alt="" aria-hidden style={decoStyle} />
          <img className="iacas-dots d1" src="/images/dot-grid.svg" alt="" aria-hidden style={decoStyle} />
          <img className="iacas-dots d2" src="/images/dot-grid.svg" alt="" aria-hidden style={decoStyle} />
          <div className="iacas-cargo">
            <img className="iacas-cargo-img" src="/images/cargo-hub.svg" alt="Pusat kargo udara" style={decoStyle} />
            <img className="iacas-awb-tag" src="/images/art-awb-tag.svg" alt="" style={decoStyle} />
            <img className="iacas-stamp" src="/images/art-customs-stamp.svg" alt="" style={decoStyle} />
            <img className="iacas-spark s1" src="/images/art-sparkle.svg" alt="" style={decoStyle} />
            <img className="iacas-spark s2" src="/images/art-sparkle.svg" alt="" style={decoStyle} />
            <img className="iacas-spark s3" src="/images/art-sparkle.svg" alt="" style={decoStyle} />
          </div>

          <FloatCard style={{ left: '7.2%', top: '19.6%', width: 300 }}>
            <div className="iacas-row">
              <span className="iacas-ico"><BoxMinimalisticIcon /></span>
              <span className="iacas-col">
                <small>Airwaybill</small>
                <code>126-4471 2290</code>
              </span>
            </div>
            <div className="iacas-row between">
              <span className="iacas-muted">CGK → SIN · 14:20</span>
              <span className="iacas-badge"><i />Gate In</span>
            </div>
          </FloatCard>

          <FloatCard style={{ left: '71.4%', top: '12.9%', width: 284 }}>
            <div className="iacas-row"><ShieldCheckIcon color={BaseColor} /> <span className="iacas-muted">Terkirim ke Bea Cukai</span></div>
            <div className="iacas-big">99,2% <small>hari ini</small></div>
            <div className="iacas-bar"><i style={{ flex: 1 }} /><i className="soft" /></div>
          </FloatCard>

          <FloatCard style={{ left: '75.3%', top: '60%', width: 240 }}>
            <small className="iacas-overline">Alur aktif</small>
            <div className="iacas-row between"><span><ArrowRightUpIcon color={BaseColor} /> Export</span><code>412</code></div>
            <div className="iacas-row between"><span><InboxLineIcon color={BaseColor} /> Import</span><code>538</code></div>
            <div className="iacas-row between"><span><RouteIcon color={BaseColor} /> Distribusi</span><code>334</code></div>
          </FloatCard>

          <FloatCard style={{ left: '9.6%', top: '66.4%', width: 232 }}>
            <div className="iacas-row"><i className="iacas-dot" /><strong>Sinkron real-time</strong></div>
            <p className="iacas-muted">Status gate &amp; dokumen diperbarui otomatis.</p>
          </FloatCard>
        </div>

        <div className="iacas-stats">
          {[
            ['3 modul', 'Export · Import · Distribusi'],
            ['Real-time', 'Sinkron dengan Bea Cukai'],
            ['24/7', 'Monitoring status pengiriman'],
            ['1 akses', 'Untuk maskapai, TPS & PJT'],
          ].map(([h, s], i) => (
            <div key={i} className={`iacas-stat${i > 0 ? ' bordered' : ''}`}>
              <strong>{h}</strong>
              <span>{s}</span>
            </div>
          ))}
        </div>
      </div>

      <footer className="iacas-footer">
        <div className="iacas-footer-top">
          <div className="iacas-logo on-dark">
            <img src="/images/iacas.png" alt="IACAS" />
            <div className="iacas-wordmark">
              <strong>IACAS</strong>
              <span>Integrated Airline &amp; Customs Automation System</span>
            </div>
          </div>
          <p className="iacas-footer-desc">
            Satu sistem untuk maskapai, gudang TPS, dan Bea Cukai supaya setiap airwaybill bergerak tanpa hambatan.
          </p>
        </div>
        <div className="iacas-footer-bottom">
          <span>© 2026 Edifly Solusi Indonesia. Hak cipta dilindungi.</span>
          <span className="iacas-footer-links">
            <span>Kebijakan Privasi</span>
            <span>Syarat &amp; Ketentuan</span>
            <span>Fe v1.0.0.0004 · Be v1.0.0.0004</span>
          </span>
        </div>
        <div className="iacas-giant" aria-hidden>IACAS</div>
      </footer>
    </div>
  );
};
